import Err from '@leverege/error'
import InvalidFieldParser from './InvalidFieldParser.js'

const openers = /^[({'"[]$/
const closers = /^[)}'"\]]$/
const closeMatches = {
  '(' : ')',
  '{' : '}',
  '\'' : '\'',
  '"' : '"',
  '[' : ']',
}

function handleAlias( field, { context } ) {
  const res = findRootToken( field, { token : 'as', context } )
  if ( res === false ) {
    return res
  }
  const { absoluteLocation, relativeLocation } = res
  return {
    field : res.pre,
    alias : res.post,
    absoluteLocation : {
      asIndex : absoluteLocation.matchIndex,
      aliasIndex : absoluteLocation.postIndex,
      aliasLength : res.post.length,
    },
    relativeLocation : {
      asIndex : relativeLocation.matchIndex,
      aliasIndex : relativeLocation.postIndex,
      aliasLength : res.post.length,
    },
  }
}

function findRootToken( field, { token : toFind, delimiter = ' ', context } ) {
  if ( !field ) {
    return false
  }
  const nField = field
  let multiClause = false
  const toMatch = Array.isArray( toFind ) ? toFind.map( tkn => tkn.toLowerCase() ) : [ toFind?.toLowerCase() ]
  // first time we hit the specified token split and return the two pieces
  const stack = []
  let token = '', index = -1, match = null
  for ( let i = 0; i < nField.length; i++ ) {
    const char = nField[i]
    if ( char.match( openers ) ) {
      stack.push( char )
    }
    if ( char.match( closers ) ) {
      if ( closeMatches[stack.at( -1 )] !== char ) {
        return handleInvalid(
          field,
          Err.illegalArgument( { message : 'bad string: unmatched parentheses', index : i, field : nField, context } ),
          context
        )
      }
      stack.pop()
      if ( stack.length === 0 && i !== nField.length - 1 ) {
        multiClause = true
      }
    }
  
    if ( char === delimiter && stack.length === 0 ) {
      const found = toMatch.find( match => match === token.trim().toLowerCase() )
      if ( found ) {
        index = i
        match = found
        break
      }
      token = ''
    } else {
      token += char
    }
  }
  if ( stack.length !== 0 ) {
    // return null
    return handleInvalid(
      field,
      Err.illegalArgument( { message : 'bad string: unmatched parentheses', index : nField.length - 1, field : nField, context } ),
      context,
    )
  }
  if ( index === -1 ) {
    if ( !multiClause && nField.startsWith( '(' ) && nField.endsWith( ')' ) ) {
      return findRootToken(
        nField.slice( 1, -1 ),
        {
          token : toFind,
          delimiter,
          context : {
            ...context,
            parenthesesDepth : ( context?.parenthesesDepth || 0 ) + 1,
            indexOffset : ( context?.indexOffset || 0 ) + 1
          }
        }
      )
    }
    return false
  }
  const absoluteOffset = ( context?.field?.startIndex || 0 ) + ( context?.indexOffset || 0 )
  const relativeOffset = 0

  const pre = nField.slice( 0, index - token.length )
  const preTrimmed = pre.trim()
  const preFrontRemoved = pre.indexOf( preTrimmed )
  const post = nField.slice( index )
  const postTrimmed = post.trim()
  const postFrontRemoved = post.indexOf( postTrimmed )

  return {
    pre : preTrimmed,
    match,
    post : nField.slice( index ).trim(),
    parenthesesDepth : context?.parenthesesDepth,
    relativeLocation : {
      preIndex : preFrontRemoved + relativeOffset,
      matchIndex : index - token.length + relativeOffset,
      postIndex : index + relativeOffset + postFrontRemoved,
    },
    absoluteLocation : {
      preIndex : absoluteOffset + preFrontRemoved,
      matchIndex : index - token.length + absoluteOffset,
      postIndex : index + absoluteOffset + postFrontRemoved,
    }
  }
}

function getAbsoluteOffset( { context } ) {
  return ( context?.field?.startIndex || 0 ) + ( context?.indexOffset || 0 )
}

function handleInvalid( field, error, context ) {
  if ( context.allowInvalidObjects ) {
    return InvalidFieldParser.parse( field, context )
  }
  throw error
}

export default {
  handleAlias,
  findRootToken,
  getAbsoluteOffset,
  handleInvalid,
}
